// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__W+YCl","title":"Unauthorized_title__TA6Nh","message":"Unauthorized_message__sWmKP","button":"Unauthorized_button__76LRU"};